import type { Bms } from '@/models/types/bms/bms'
import type { BMSDTO } from '@/models/dto/bms/bms-dto'
import { mapToBMSSensor, mapToBMSSensoreDto } from '@/models/mappers/bms/bms-sensor-mapper'

const mapToBMS = (dto: BMSDTO): Bms => {
    return {
        id: dto.id,
        name: dto.nome ?? undefined,
        bmsAliasId: dto.idImpiantoBMSAlias ?? undefined,
        facilityId: dto.idImpianto ?? undefined,
        facilityIconUrl: dto.iconUrl ?? undefined,
        facilityName: dto.nomeImpianto ?? undefined,
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        bmsSensors: dto.sensori ? dto.sensori.map(mapToBMSSensor) : [],
        stanzePredefinite: dto.stanzePredefinite ?? undefined,
        attributiPredefiniti: dto.attributiPredefiniti ?? undefined,
    }
}

const mapToBmsDTO = (bms: Bms): BMSDTO => {
    return {
        id: bms.id,
        nome: bms.name ?? '',
        idImpiantoBMSAlias: bms.bmsAliasId ?? '',
        nomeImpianto: bms.facilityName ?? '',
        idImpianto: bms.facilityId ?? null,
        iconUrl: bms.facilityIconUrl ?? null,
        stanzePredefinite: bms.stanzePredefinite ?? [],
        attributiPredefiniti: bms.attributiPredefiniti ?? [],
        sensori: bms.bmsSensors?.map(mapToBMSSensoreDto) ?? [],
    }
}

export { mapToBMS, mapToBmsDTO }
